(function ($) {
  $(function () {
    //slick初始化
    initSlick()
    function initSlick() {
      const $gallery = $(".product_info .product_gallery_slick");

      $gallery.slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        waitForAnimate: false,
        autoplay: true,
        pauseOnHover: false,
        dots: true,
        autoplaySpeed: 5000,
        draggable: false,
      });

      $(document).on('click.slickPrevGallery', ".product_info .product_gallery_slick_prev", function () {
        $(".product_info .product_gallery_slick").slick("slickPrev");
      });

      $(document).on('click.slickNextGallery', ".product_info .product_gallery_slick_next", function () {
        $(".product_info .product_gallery_slick").slick("slickNext");
      });

      const $recommend = $(".product_info .product_recommend_slick_body");

      $recommend.slick({
        variableWidth: true,
        slidesToScroll: 1,
        arrows: false,
        waitForAnimate: false,
        infinite: false,
      });

      $(document).on('click.slickPrevRecommend', ".product_info .product_recommend_slick_prev", function () {
        $(".product_info .product_recommend_slick_body").slick("slickPrev");
      });

      $(document).on('click.slickNextRecommend', ".product_info .product_recommend_slick_next", function () {
        $(".product_info .product_recommend_slick_body").slick("slickNext");
      });

      $recommend.on('afterChange', function (event, slick, current) {
        const currentSlide = current ?? slick.currentSlide;
        const lastSlide = slick.slideCount - 1;

        if (currentSlide > 0) {
          $('.product_info .product_recommend_slick_prev').removeClass('hidden');
        } else {
          $('.product_info .product_recommend_slick_prev').addClass('hidden');
        }

        if (currentSlide >= lastSlide) {
          $('.product_info .product_recommend_slick_next').addClass('hidden');
        } else {
          $('.product_info .product_recommend_slick_next').removeClass('hidden');
        }
      });
    }

    const gallery = document.querySelector(".product_gallery");
    const btnExpand = document.querySelector('.product_gallery_btn[data-type="expand"]');
    const btnClose = document.querySelector('.product_gallery_btn[data-type="close"]');

    // 进入全屏
    btnExpand.addEventListener("click", () => {
      gallery.requestFullscreen().catch(err => console.error(err));
    });

    // 退出全屏
    btnClose.addEventListener("click", () => {
      document.exitFullscreen();
    });

    // 监听全屏切换
    document.addEventListener("fullscreenchange", () => {
      const isFull = !!document.fullscreenElement;

      // 切换按钮 hidden
      if (isFull) {
        btnExpand.classList.add("hidden");
        btnClose.classList.remove("hidden");
      } else {
        btnExpand.classList.remove("hidden");
        btnClose.classList.add("hidden");
      }

      // slick 进入全屏后刷新尺寸
      if (isFull) {
        setTimeout(() => {
          $(".product_gallery_slick").slick("setPosition");
        }, 80);
      }
    });

    const accordionItems = document.querySelectorAll(".product_accordion_item");

    accordionItems.forEach((item) => {
      const head = item.querySelector(".product_accordion_item_head");

      head.addEventListener("click", () => {
        const isOpen = item.hasAttribute("open");

        // 同层级最多展开 1 个
        accordionItems.forEach((i) => i.removeAttribute("open"));

        // 原本未展开则切换打开
        if (!isOpen) {
          item.setAttribute("open", "");
        }
      });
    });

    const faqItems = document.querySelectorAll(".product_info_faqs_item");

    faqItems.forEach((item) => {
      const head = item.querySelector(".product_info_faqs_item_head");
      const iconOpen = item.querySelector('[data-type="open"]');
      const iconClose = item.querySelector('[data-type="close"]');

      head.addEventListener("click", () => {
        const isOpen = item.hasAttribute("open");

        // 同层级最多展开 1 个
        faqItems.forEach((i) => {
          i.removeAttribute("open");
          const io = i.querySelector('[data-type="open"]');
          const ic = i.querySelector('[data-type="close"]');
          if (io && ic) {
            io.classList.add("hidden");
            ic.classList.remove("hidden");
          }
        });

        // 如果之前是关闭的 → 展开
        if (!isOpen) {
          item.setAttribute("open", "");
          iconOpen.classList.remove("hidden");
          iconClose.classList.add("hidden");
        }
      });
    });

    const size_switch_btn = document.querySelector(".product_info_size_switch")
    size_switch_btn.addEventListener("click", () => {
      size_switch_btn.toggleAttribute("checked")
      const options = size_switch_btn.closest(".product_info_option").querySelectorAll(".product_info_option_item")
      if (size_switch_btn.hasAttribute("checked")) {
        size_switch_btn.querySelector(".product_info_size_switch_text").innerHTML = "mm"
        options.forEach(item => {
          item.innerHTML = item.getAttribute("data-size-mm")
        })
      } else {
        size_switch_btn.querySelector(".product_info_size_switch_text").innerHTML = "in"
        options.forEach(item => {
          item.innerHTML = item.getAttribute("data-size-in").replaceAll('/', '"')
        })
      }
    })

    setupToggleBox(".product_info_size_tips", ".product_info_size_tips_text");
    setupToggleBox(".product_info_size_custom", ".product_info_size_custom_text");

    function setupToggleBox(wrapperSelector, boxSelector) {
      const wrapper = document.querySelector(wrapperSelector);
      const box = document.querySelector(boxSelector);
      if (!wrapper || !box) return;

      wrapper.addEventListener("click", (e) => {
        if (box.contains(e.target)) return;
        box.classList.toggle("hidden");
      });

      document.addEventListener("click", (e) => {
        if (wrapper.contains(e.target)) return;
        box.classList.add("hidden");
      });
    }

    function getDateRange24to26() {
      const today = new Date();

      const d24 = new Date(today);
      d24.setDate(today.getDate() + 24);

      const d26 = new Date(today);
      d26.setDate(today.getDate() + 26);

      const format = (d) =>
        d.toLocaleDateString("en-US", {
          month: "short",
          day: "numeric",
        });

      return `${format(d24)} – ${format(d26)}`;
    }

    document.querySelector(".product_info_arrival_text").innerHTML = getDateRange24to26()

    document.querySelector(".product_info .product_info_upload_box").addEventListener("click", () => {
      document.querySelector(".product_info #customFile").click()
    })
    // 存储上传成功后的 URL
    let uploadFileUrls = [];

    document.querySelector(".product_info #customFile").addEventListener("change", async (e) => {
      const file = e.target.files[0];
      if (!file) return;

      const formData = new FormData();
      formData.append("image", file);
      formData.append("shop_name", "bulijojo");

      try {
        const res = await fetch("http://shopify.iwxjx.com/api/Upload/uploadImage", {
          method: "POST",
          body: formData
        });

        const result = await res.json();

        if (result.code !== 200) {
          console.error("上传失败:", result);
          return;
        }

        const { url, filename, size } = result.data;

        // push 对象 { filename, url }
        uploadFileUrls.push({ filename, url });

        const fileSizeKB = (size / 1024).toFixed(1) + " kB";

        const container = document.querySelector(".product_info_upload_result");

        const item = document.createElement("div");
        item.className = "product_info_upload_result_item";

        item.innerHTML = `
          <div>
            <div class="product_info_upload_result_item_title">${filename}</div>
            <div>${fileSizeKB}</div>
          </div>
          <svg
            stroke="currentColor"
            fill="currentColor"
            stroke-width="0"
            viewBox="0 0 20 20"
            aria-hidden="true"
            class="w-6 h-6 text-core-tree-100 upload_remove_btn"
            height="1em"
            width="1em"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path fill-rule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clip-rule="evenodd"></path>
          </svg>
        `;

        // 删除逻辑同步更新：根据 filename + url 删除对象
        item.querySelector(".upload_remove_btn").addEventListener("click", () => {
          uploadFileUrls = uploadFileUrls.filter(fileObj => fileObj.url !== url);
          item.remove();
        });

        document.querySelector(".product_info_upload_message").classList.add("hidden")
        container.appendChild(item);

        setTimeout(() => {
          item.classList.add("full");
        }, 0);

      } catch (err) {
        console.error("上传失败:", err);
      }
    });


    document
  .querySelectorAll(".product_info .product_info_option_item")
  .forEach(optionItem => {
    optionItem.addEventListener("click", () => {
      const disabledClass = "product_info_option_item_diasbled";
      const activeClass = "product_info_option_item_active";

      if (
        optionItem.classList.contains(activeClass) ||
        optionItem.classList.contains(disabledClass)
      ) {
        return;
      }

      const parent = optionItem.closest(".product_info_option");
      if (!parent) return;

      const type = parent.getAttribute("data-type");

      if (type === "Color") {
        const colorText = parent.querySelector(".product_info_option_head_left_text");
        if (colorText) {
          colorText.textContent = optionItem.getAttribute("data-name") || "";
        }
      }

      const currentActive = parent.querySelector(`.${activeClass}`);
      if (currentActive) {
        currentActive.classList.remove(activeClass);
      }

      optionItem.classList.add(activeClass);

      // 动态获取所有规格选中的值
      const selectedOptions = Array.from(
        document.querySelectorAll(".product_info_option")
      )
        .sort((a, b) => {
          return Number(a.dataset.index) - Number(b.dataset.index);
        })
        .map(option => {
          const activeItem = option.querySelector(`.${activeClass}`);
          return activeItem
            ? activeItem.getAttribute("data-value")?.replaceAll("/", '\\"')
            : null;
        })
        .filter(value => value !== null);

      // 根据实际存在的 option 数量匹配 variant
      const variant = product.variants.find(variantItem => {
        return selectedOptions.every((value, index) => {
          return variantItem[`option${index + 1}`] === value;
        });
      });

      if (!variant) return;

      const goodsInput = document.querySelector("input[name='goods_id']");
      if (goodsInput) {
        goodsInput.value = variant.id;
      }
    });
  });

    document.querySelectorAll(".product_info .product_info_quantity_line_select").forEach(item => {
      item.addEventListener("click", () => {
        if (item.classList.contains("active")) return
        const parent = item.closest(".product_info_quantity_body")
        parent.querySelector(".product_info_quantity_line_select.active").classList.remove("active")
        item.classList.add("active")
        if (item.classList.contains("need_quote")) {
          document.querySelector(".product_info_btns_item[data-type='add_to_cart']").classList.add("hidden")
          document.querySelector(".product_info_btns_item[data-type='quote']").classList.remove("hidden")
          document.querySelector(".product_info_total").classList.add("hidden")
        } else {
          document.querySelector(".product_info_btns_item[data-type='add_to_cart']").classList.remove("hidden")
          document.querySelector(".product_info_btns_item[data-type='quote']").classList.add("hidden")
          document.querySelector(".product_info_total").classList.remove("hidden")
          document.querySelector(".product_info_total_price").innerHTML = item.querySelector(".product_amount").innerHTML
        }
      })
    })

    document.querySelectorAll(".product_info .product_info_btns_item").forEach(item => {
      item.addEventListener("click", () => {
        const type = item.getAttribute("data-type");
        if (type === "add_to_cart") {
          item.classList.add("is-loading");
          // if (uploadFileUrls.length === 0) {
          //   document.querySelector(".product_info_upload_message").classList.remove("hidden")
          //   item.classList.remove("is-loading");
          //   return
          // }
          const goods_id = document.querySelector("input[name='goods_id']").value;
          const quantity = document.querySelector(".product_info_quantity_line_select.active")
            .getAttribute("data-value");

          const cartItem = {
            id: goods_id,
            quantity: Number(quantity),
            properties: {},
          };

          const colorDom = document.querySelector(".product_info_option[data-type='Color'] .product_info_option_item_active");
          if (colorDom) {
            cartItem.properties.Color = colorDom.getAttribute("data-value");
          }

          uploadFileUrls.forEach((file, index) => {
            const num = index + 1;
            cartItem.properties[`Artwork${num}`] = file.url;
          });

          const cartFormData = { items: [cartItem] };

          const body = JSON.stringify({
            ...cartFormData,
            sections: getSectionsToRender().map((section) => section.section),
            sections_url: window.location.pathname,
          });

          fetch(`${routes.cart_add_url}`, { ...fetchConfig(), ...{ body } })
            .then((response) => response.text())
            .then((state) => {
              const parsedState = JSON.parse(state);
              if (parsedState.errors) {
                alert(parsedState.errors)
                return
              }
              getSectionsToRender().forEach((section) => {
                const elementToReplace =
                  document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
                elementToReplace.innerHTML = getSectionInnerHTML(
                  parsedState.sections[section.section],
                  section.selector
                );
              });
              document.body.classList.add('overflow-hidden');
              const theme_cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
              if (theme_cart && theme_cart.classList.contains('is-empty')) theme_cart.classList.remove('is-empty');
              setTimeout(() => {
                theme_cart.classList.add('animate', 'active');
              });
            })
            .catch((e) => {
              console.error('Error updating cart sections:', e);
            }).finally(() => {
              item.classList.remove("is-loading");
            });
        }
      });
    });

    function getSectionsToRender() {
      return [
        {
          id: 'CartDrawer',
          section: 'cart-drawer',
          selector: '.drawer__inner',
        },
        {
          id: 'cart-icon-bubble',
          section: 'cart-icon-bubble',
          selector: '.shopify-section',
        },
      ];
    }
    function getSectionInnerHTML(html, selector) {
      return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
    }

    document.querySelector(".product_info_size_custom_btn").addEventListener("click", () => {
      document.querySelector('.help_modal_btn').click()
    })
    document.querySelector(".product_info_quantity_more_title_btn").addEventListener("click", () => {
      document.querySelector('.help_modal_btn').click()
    })
    document.querySelector(".product_info_btns_item[data-type='quote']").addEventListener("click", () => {
      document.querySelector('.help_modal_btn').click()
    })
  });
})(jQuery);
